<script lang="ts">
	import type { PageServerData } from "./$types";

  import { page } from "$app/stores";
  import { Vertical } from "$lib/def/verticals";
  import { profile$ } from "$lib/serv/core/auth";
  import { landingItemsParams$, setLandingItemsParams } from "$lib/serv/locations";

	import FoodLanding from "$lib/ui/home/FoodLanding.svelte";
	import GrocLanding from "$lib/ui/home/GrocLanding.svelte";
	import HomeVerticalIntros from "$lib/ui/home/HomeVerticalIntros.svelte";
	import RestaurantPage from "$lib/ui/home/seo/RestaurantPage.svelte";
	import AddressSelect from "$lib/ui/layout/AddressSelect.svelte";
	import LoadingIcons from "$lib/ui/shared/LoadingIcons.svelte";
	import Meta from "$lib/ui/shared/seo/Meta.svelte";

	export let data: PageServerData;
	
  $: setLandingItemsParams(Object.fromEntries($page.url.searchParams.entries()));
	$: vertical = $page.url.searchParams.get('vertical') as Vertical ?? Vertical.Restaurant
	$: content = data.pages?.find((v) => v.slug === `home-${vertical}`);
</script>

<svelte:head>
	<Meta meta={data.meta}/>
	<link rel="canonical" href={data.canonical} />
</svelte:head>

{#if landingItemsParams$}
	{@const liParams = $landingItemsParams$}
	{#if liParams && liParams.hasGeo}
		{#if vertical === Vertical.Grocery}
			<GrocLanding page={$page} />
		{:else}
			<FoodLanding page={$page} />
		{/if}
	{:else if liParams && (data.auth || $profile$ || !content)}
		<div class="max-w-700 m-auto">
			<AddressSelect currentURL={$page.url} />
		</div>
		<!-- Uses auth cookie so SSR works -->
	{:else if liParams && content}
		{#if vertical === Vertical.Restaurant}
			<RestaurantPage
				content={content}
				{data}
			/>
		{:else if liParams}
			<HomeVerticalIntros {content}/>
		{/if}
	{:else}
		<LoadingIcons />
	{/if}
{/if}

<!-- Order progress float can be lazy loaded -->
{#await import('$lib/ui/order/OrderInProgress.svelte')}
	<!-- <LoadingIcons /> -->
{:then OrderInProgress}
	<OrderInProgress.default {vertical} />
{:catch error}
	<!-- Failed to load OrderInProgress {error} --><!-- Perhaps let hide this fact as not knowing is better than showing this horrible text-->
{/await}

<!--
{#if showCookieNotice}
		{@const cookieMsg = `Please note that we use cookies to offer you a better user experience, analyse site traffic, and better serve advertising. By continuing to use this website, you consent to the use of cookies in accordance with our Privacy Policy`}
		<!- TODO: If cookie chats resurrect, please check if this works >.< ->
	<Alert 
		message={cookieMsg} 
		type={AlertType.Cookie} 
		button={'Accept Cookies'}
		onDismiss={setCookie} />
{/if} -->
